import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-787523c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frisbuy-mobile-video-controls" }
const _hoisted_2 = { class: "frisbuy-mobile-video-controls__top" }
const _hoisted_3 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "1",
  y: "1",
  width: "2.4",
  height: "8",
  rx: "0.8",
  fill: "white"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "6.2",
  y: "1",
  width: "2.4",
  height: "8",
  rx: "0.8",
  fill: "white"
}, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M11.2 7L3.2 11.5V2.5L11.2 7Z",
  fill: "white"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "frisbuy-mobile-video-controls__time" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "frisbuy-mobile-video-controls__spacer" }, null, -1))
const _hoisted_12 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M3.5 8H6.5L10 5.5V14.5L6.5 12H3.5V8Z",
  stroke: "white",
  "stroke-width": "1.8",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12.8 8L16 11.2",
  stroke: "white",
  "stroke-width": "1.8",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M16 8L12.8 11.2",
  stroke: "white",
  "stroke-width": "1.8",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M3.5 8H6.5L10 5.5V14.5L6.5 12H3.5V8Z",
  stroke: "white",
  "stroke-width": "1.8",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12.6 8.1C13.5 9 13.5 10.5 12.6 11.4",
  stroke: "white",
  "stroke-width": "1.8",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M14.8 6.4C16.7 8.3 16.7 11.3 14.8 13.2",
  stroke: "white",
  "stroke-width": "1.8",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_21 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" data-v-787523c8><path d=\"M2.8 7V2.8H7\" stroke=\"white\" stroke-width=\"1.6\" stroke-linecap=\"round\" data-v-787523c8></path><path d=\"M11 2.8H15.2V7\" stroke=\"white\" stroke-width=\"1.6\" stroke-linecap=\"round\" data-v-787523c8></path><path d=\"M15.2 11V15.2H11\" stroke=\"white\" stroke-width=\"1.6\" stroke-linecap=\"round\" data-v-787523c8></path><path d=\"M7 15.2H2.8V11\" stroke=\"white\" stroke-width=\"1.6\" stroke-linecap=\"round\" data-v-787523c8></path></svg>", 1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["aria-expanded"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_28 = [
  _hoisted_25,
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = ["max", "value"]

import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import PopupReviewMobileVideoSpeedMenu from "./PopupReviewMobileVideoSpeedMenu.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupReviewMobileVideoControls',
  props: {
    videoEl: {}
  },
  setup(__props: any) {

const props = __props;

const video = computed(() => props.videoEl);
const currentTime = ref(0);
const duration = ref(0);
const isPlaying = ref(false);
const isMuted = ref(false);
const playbackRate = ref(1);
const isSpeedMenuOpen = ref(false);
const speedMenuWrapRef = ref<HTMLElement | null>(null);

function sync() {
  if (!video.value) return;
  currentTime.value = video.value.currentTime || 0;
  duration.value = Number.isFinite(video.value.duration) ? video.value.duration : 0;
  isPlaying.value = !video.value.paused;
  isMuted.value = video.value.muted || video.value.volume === 0;
  playbackRate.value = Number.isFinite(video.value.playbackRate) ? video.value.playbackRate : 1;
}

function onTimeUpdate() {
  if (!video.value) return;
  currentTime.value = video.value.currentTime || 0;
}

function onDurationChange() {
  if (!video.value) return;
  duration.value = Number.isFinite(video.value.duration) ? video.value.duration : 0;
}

function onPlay() {
  isPlaying.value = true;
}

function onPause() {
  isPlaying.value = false;
}

function onVolumeChange() {
  if (!video.value) return;
  isMuted.value = video.value.muted || video.value.volume === 0;
}

function bind(el: HTMLVideoElement | null, prev?: HTMLVideoElement | null) {
  if (prev) {
    prev.removeEventListener("timeupdate", onTimeUpdate);
    prev.removeEventListener("durationchange", onDurationChange);
    prev.removeEventListener("play", onPlay);
    prev.removeEventListener("pause", onPause);
    prev.removeEventListener("volumechange", onVolumeChange);
  }

  if (!el) return;

  el.addEventListener("timeupdate", onTimeUpdate);
  el.addEventListener("durationchange", onDurationChange);
  el.addEventListener("play", onPlay);
  el.addEventListener("pause", onPause);
  el.addEventListener("volumechange", onVolumeChange);
  sync();
}

watch(video, (el, prev) => bind(el, prev), { immediate: true });

onBeforeUnmount(() => {
  bind(null, video.value || undefined);
  document.removeEventListener("pointerdown", onDocumentPointerDown);
  document.removeEventListener("keydown", onDocumentKeydown);
});

onMounted(() => {
  document.addEventListener("pointerdown", onDocumentPointerDown);
  document.addEventListener("keydown", onDocumentKeydown);
});

function togglePlay() {
  if (!video.value) return;
  if (video.value.paused) {
    video.value.play();
    return;
  }
  video.value.pause();
}

function toggleMute() {
  if (!video.value) return;
  video.value.muted = !video.value.muted;
  isMuted.value = video.value.muted;
}

function toggleFullscreen() {
  if (!video.value) return;

  if (document.fullscreenElement) {
    document.exitFullscreen();
    return;
  }

  const parent = video.value.parentElement;
  const target = parent || video.value;
  const anyTarget = target as HTMLElement & {
    webkitRequestFullscreen?: () => void;
  };
  const anyVideo = video.value as HTMLVideoElement & {
    webkitEnterFullscreen?: () => void;
  };

  if (target.requestFullscreen) {
    target.requestFullscreen();
  } else if (anyTarget.webkitRequestFullscreen) {
    anyTarget.webkitRequestFullscreen();
  } else if (anyVideo.webkitEnterFullscreen) {
    anyVideo.webkitEnterFullscreen();
  }
}

function seek(event: Event) {
  if (!video.value) return;
  const target = event.target as HTMLInputElement;
  video.value.currentTime = Number(target.value);
  currentTime.value = video.value.currentTime;
}

function toggleSpeedMenu() {
  isSpeedMenuOpen.value = !isSpeedMenuOpen.value;
}

function setPlaybackRate(rate: number) {
  playbackRate.value = rate;
  if (!video.value) return;
  video.value.playbackRate = rate;
}

function onDocumentPointerDown(event: PointerEvent) {
  if (!isSpeedMenuOpen.value) return;
  const target = event.target as Node | null;
  if (!target) return;
  if (speedMenuWrapRef.value?.contains(target)) return;
  isSpeedMenuOpen.value = false;
}

function onDocumentKeydown(event: KeyboardEvent) {
  if (event.key !== "Escape") return;
  isSpeedMenuOpen.value = false;
}

function formatTime(time: number) {
  const safe = Number.isFinite(time) ? Math.max(0, Math.floor(time)) : 0;
  const minutes = Math.floor(safe / 60);
  const seconds = safe % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "frisbuy-mobile-video-controls__btn frisbuy-mobile-video-controls__btn--play",
        "aria-label": "Play / pause",
        onClick: togglePlay
      }, [
        (isPlaying.value)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_6))
          : (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9))
      ]),
      _createElementVNode("span", _hoisted_10, _toDisplayString(formatTime(currentTime.value)) + " / " + _toDisplayString(formatTime(duration.value)), 1),
      _hoisted_11,
      _createElementVNode("button", {
        type: "button",
        class: "frisbuy-mobile-video-controls__btn",
        "aria-label": "Mute / unmute",
        onClick: toggleMute
      }, [
        (isMuted.value)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_16))
          : (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_21))
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "frisbuy-mobile-video-controls__btn",
        "aria-label": "Fullscreen",
        onClick: toggleFullscreen
      }, _hoisted_23),
      _createElementVNode("div", {
        ref_key: "speedMenuWrapRef",
        ref: speedMenuWrapRef,
        class: "frisbuy-mobile-video-controls__menu-wrap"
      }, [
        _createElementVNode("button", {
          type: "button",
          class: "frisbuy-mobile-video-controls__btn frisbuy-mobile-video-controls__btn--dots",
          "aria-label": "More",
          "aria-haspopup": "menu",
          "aria-expanded": isSpeedMenuOpen.value,
          onClick: toggleSpeedMenu
        }, _hoisted_28, 8, _hoisted_24),
        (isSpeedMenuOpen.value)
          ? (_openBlock(), _createBlock(PopupReviewMobileVideoSpeedMenu, {
              key: 0,
              modelValue: playbackRate.value,
              "onUpdate:modelValue": setPlaybackRate,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (isSpeedMenuOpen.value = false))
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    _createElementVNode("input", {
      class: "frisbuy-mobile-video-controls__progress",
      type: "range",
      min: "0",
      max: duration.value || 0,
      step: "0.01",
      value: currentTime.value,
      onInput: seek,
      "aria-label": "Seek"
    }, null, 40, _hoisted_29)
  ]))
}
}

})